import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { DefaultBorder } from '../../../../web/styles/styles';

const ColumnSpacing = 60;
const FirstColumnSpacing = 30;
const ActionsColumnWidth = 70;
const CreationDateColumnWidth = 70;
const IndustriesColumnWidth = 180;
const GripperColumnWidth = 12;

export const styleSheet = StyleSheet.create({
	container: {
		width: '100%',
	},
	header: {
		alignItems: 'center',
		borderBottom: DefaultBorder,
		boxSizing: 'border-box',
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.xxs,
		letterSpacing: '1.1px',
		padding: `${THEME.spacing.lg}px 0`,
		textTransform: 'uppercase',
	},
	row: {
		alignItems: 'center',
		borderBottom: DefaultBorder,
		boxSizing: 'border-box',
		display: 'flex',
		padding: `${THEME.spacing.lg}px 0`,
		':hover': {
			backgroundColor: THEME.colors.background.light,
		},
	},
	gripperCol: {
		flexShrink: 0,
		width: GripperColumnWidth,
	},
	nameCol: {
		display: 'flex',
		flexGrow: 1,
		marginLeft: FirstColumnSpacing,
	},
	nameButton: {
		background: 'none',
		border: 'none',
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
		padding: 0,
		textAlign: 'left',
		width: '100%',
		':hover': {
			textDecoration: 'underline',
		},
	},
	industriesCol: {
		flexShrink: 0,
		marginLeft: ColumnSpacing,
		width: IndustriesColumnWidth,
		fontSize: THEME.typography.fontSizes.sm,
	},
	creationDateCol: {
		flexShrink: 0,
		marginLeft: ColumnSpacing,
		width: CreationDateColumnWidth,
		fontSize: THEME.typography.fontSizes.sm,
	},
	actionsCol: {
		flexShrink: 0,
		marginLeft: ColumnSpacing,
		width: ActionsColumnWidth,
		display: 'flex',
		justifyContent: 'center',
	},
	actionsButton: {
		cursor: 'pointer',
	},
	loadingSpinner: {
		marginTop: THEME.spacing.lg,
	},
	inlineSpinner: {
		display: 'inline-block',
		marginLeft: THEME.spacing.sm,
		verticalAlign: 'middle',
	},
	emptyState: {
		padding: `${THEME.spacing.xl}px 0`,
		textAlign: 'center',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
